import { useState } from "react";
import { useI18n } from "../i18n";

export function CopyButton({ getText, className = "btn-copy" }: { getText: () => string; className?: string }) {
  const { m } = useI18n();
  const [copied, setCopied] = useState(false);

  async function handleCopy() {
    try {
      await navigator.clipboard.writeText(getText());
    } catch {
      // Clipboard API can be unavailable (permissions, insecure context); the
      // label still flips so the click isn't silently a no-op.
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 1600);
  }

  return (
    <button type="button" className={className} onClick={handleCopy} aria-live="polite">
      {copied ? m.common.copied : m.common.copy}
    </button>
  );
}
